<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <!-- <link rel="icon" href="img/favicon.ico">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" type="text/css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/font-awesome.min.css" type="text/css">
  <link rel="stylesheet" href="theme.css" type="text/css"> -->
      <title>Porto - Portal de Autonegociação</title>
    </head>

    <body>
      <div class="capa1" style="">
        <div class="container">
          <div class="row" v-if="!notExists">
            <div class="pt-4 col-lg-5">
              <h1 class="pl-0 text-white col-1 d-none d-lg-block mt-5 col-lg-12" style="">Negocie suas dívidas para você ficar no azul!</h1>
            </div>
            <div class="col-md-6 col-12 col-sm-10 col-lg-4">
              <div class="mx-auto bg-light p-3 lpp4">
                <div class="border-top-0 py-3 px-3">
                  <h4 class="">Olá, {{ accessname }}<br /></h4>
                  <h5 class="text-muted">Preencha os campos abaixo</h5>
                  <h6>
                    CPF / CNPJ
                    <span class="badge badge-light">
                      Digite os 4 primeiros números</span
                    >
                  </h6>
                  <p class="text-muted text-left small mb-1">
                    Por segurança, digite apenas os 4 primeiros dígitos do seu
                    CPF ou CNPJ:
                  </p>
                  <form v-on:submit="dologin" v-on:submit.prevent id="form">
                    <div class="input-group mb-3">
                      <input
                        type="text"
                        aria-label="cpf-cnpj"
                        aria-describedby="basic-addon"
                        class="form-control"
                        v-model="form.accessdoc"
                        :disabled="loading"
                        v-mask="['####']"
                      />
                      <div
                        class="input-group-append d-flex justify-content-start"
                      >
                        <span
                          class="input-group-text text-left"
                          id="basic-addon"
                          >xx.xxx-xx ou x.xxx/xxxx-xx</span
                        >
                      </div>
                    </div>
                    <div class="form-group mb-2">
                      <p class="text-left small mb-1 text-muted">
                        Digite o código de acesso que recebeu:
                      </p>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Código de acesso"
                        id="form"
                        label="Digite"
                        v-model="form.accesscode"
                        :disabled="loading"
                      />
                    </div>
                    <div class="col-md-8" style="padding: 0px">
                      <div
                        v-if="promoCodeErrors.length"
                        style="text-align: left; font-size: 11px"
                      >
                        <b
                          v-for="error in promoCodeErrors"
                          v-bind:key="error"
                          v-bind:class="classMessage"
                          class="form-text"
                          >{{ error }}</b
                        >
                      </div>
                    </div>
                    <button
                      v-if="!loading"
                      type="submit"
                      class="btn btn-primary btn-lg d-flex my-4 mx-auto text-white"
                    >
                      Prosseguir
                    </button>
                  </form>
                  <div class="mt-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else>
            <h2 style="color: #fff;">Link de acesso vencido! Por favor, use um link válido.</h2>
          </div>
        </div>
      </div>

      <div class="sec10 bg-light">
        <div class="container">
          <div class="row justify-content-center text-center mb-5">
            <div class="col-md-12 text-dark">
              <h2 class="py-4">
                Como fazer a negociação online do seu Cartão de Crédito Porto
                Bank
              </h2>
            </div>
          </div>
          <div class="row d-flex justify-content-center text-dark">
            <div class="col-6 col-lg-3 p-2 pl-3 pr-4">
              <img class="img-fluid d-block mb-3" src="/img/ic01.jpg" />
              <h5>Identifique-se fazendo o login.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic02.jpg" />
              <h5>Selecione a melhor opção para você.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic03.jpg" />
              <h5 class="">Gere o boleto e faça o pagamento.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic04.jpg" />
              <h5 class="">Pronto! Tudo certo com a sua negociação.</h5>
            </div>
          </div>
        </div>
      </div>

      <section class="bg-light py-3">
        <div class="container py-5">
          <div class="row">
            <div class="col-11 mx-auto">
              <h4>
                Tire suas dúvidas sobre a Negociação de Dívidas
                <hr style="border-color: #fff" />
              </h4>
              <div class="accordion" id="faq">
                <div class="card m-0 px-0">
                  <div class="card-header p-2" id="headingOne">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link text-left btn-block"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                        style="font-size: 16px"
                      >
                        O que é a Negociação de Dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse1"
                    class="collapse"
                    aria-labelledby="heading1"
                  >
                    <div class="card-body px-4">
                      É uma forma de encontrar o caminho mais fácil para
                      negociar as suas dívidas em nossos produtos financeiros.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading2">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed text-left btn-block"
                        type="button"
                        aria-expanded="false"
                        data-target="#collapse2"
                        aria-controls="collapse2"
                        data-toggle="collapse"
                        style="font-size: 16px"
                      >
                        De que forma posso pagar a negociação do cartão de
                        crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse2"
                    class="collapse"
                    aria-labelledby="heading2"
                  >
                    <div class="card-body px-4">
                      Você pode realizar o pagamento por meio de boleto bancário
                      no portal ou pela central de atendimento.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading3">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed text-left btn-block"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                        style="font-size: 16px"
                      >
                        Quanto tempo leva, após o pagamento, para sair das
                        restrições de crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse3"
                    class="collapse"
                    aria-labelledby="heading3"
                  >
                    <div class="card-body px-4">
                      Após o pagamento da negociação, são até 5 dias úteis para
                      que seu nome não esteja mais restrito.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading4">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed text-left btn-block"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                        style="font-size: 16px"
                      >
                        Como posso emitir uma segunda via de boleto de
                        negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse4"
                    class="collapse"
                    aria-labelledby="heading4"
                  >
                    <div class="card-body px-4">
                      Para cartão de crédito, acesse o portal e emita a segunda
                      via de boleto. Para os demais produtos, entre em contato
                      com a central de atendimento disponível e solicite a
                      segunda via.
                    </div>
                  </div>
                </div>
                <div class="card text-left">
                  <div class="card-header p-2" id="heading4">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed text-left btn-block"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                        style="font-size: 16px"
                      >
                        Qual é o prazo para pagamento do boleto da negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse5"
                    class="collapse"
                    aria-labelledby="heading5"
                  >
                    <div class="card-body px-4">
                      Você tem até 15 dias para pagar o boleto da negociação de
                      dívida.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading6">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed text-left btn-block"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="false"
                        aria-controls="collapse6"
                        style="font-size: 16px"
                      >
                        Tenho condições especiais para negociar as minhas
                        dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse6"
                    class="collapse"
                    aria-labelledby="heading6"
                  >
                    <div class="card-body px-4">
                      Para conferir as condições de negociação do cartão de
                      crédito, acesse a nossa página. Para os demais produtos,
                      entre em contato com as centrais de atendimento
                      disponíveis e consulte se há uma oferta personalizada para
                      você.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading7">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse7"
                        aria-expanded="false"
                        aria-controls="collapse7"
                        style="font-size: 16px"
                      >
                        O que é o Programa Desenrola Brasil?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse7"
                    class="collapse"
                    aria-labelledby="heading7"
                    style=""
                  >
                    <div class="card-body px-4">
                      O Desenrola Brasil é uma iniciativa do Governo Federal
                      para ajudar na negociação de dívidas das pessoas com CPF
                      negativado. As dívidas participantes serão aquelas
                      negativadas pelos credores junto aos órgãos de crédito
                      entre 01/01/2019 e 31/12/2022. Para consultar sua
                      situação, entre em contato com o Serasa, Boa Vista e Quod.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading8">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse8"
                        aria-expanded="false"
                        aria-controls="collapse8"
                        style="font-size: 16px"
                      >
                        Quem está elegível ao Desenrola Brasil?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse8"
                    class="collapse"
                    aria-labelledby="heading8"
                    style=""
                  >
                    <div class="card-body px-4">
                      O Desenrola Brasil contempla duas faixas de público:
                      <br /><br />

                      Faixa 1: pessoas físicas com renda mensal de até 2
                      salários-mínimos ou que estejam inscritas no Cadastro
                      único para Programas Sociais do Governo Federal (Cadúnico)
                      que possuam dívidas negativadas com bancos e/ou
                      prestadoras de serviço de até R$ 5 mil. <br /><br />

                      Faixa 2: pessoas físicas com renda mensal de até R$ 20 mil
                      que possuem dívidas com bancos e inscritas em cadastros de
                      inadimplentes até 31/12/2022. <br /><br />

                      Para as duas fases, o prazo final de adesão é até
                      31/12/2023.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading9">
                    <h5 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse9"
                        aria-expanded="false"
                        aria-controls="collapse9"
                        style="font-size: 16px"
                      >
                        Como negociar dívidas no Desenrola Brasil?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse9"
                    class="collapse"
                    aria-labelledby="heading9"
                    style=""
                  >
                    <div class="card-body px-4">
                      Clientes Faixa 1: a partir de setembro/23, em data a ser
                      informada, poderão acessar o portal oficial do Desenrola
                      Brasil, via site gov.br, que está em construção.
                      <br /><br />

                      Clientes Faixa 2: desde 17/07/2023, podem negociar as
                      dívidas diretamente nos canais de atendimento Porto Bank.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </body>
  </html>
</template>

<script>
import { mapActions } from "vuex";
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProgressLoading from "../../modules/auth/components/ProgressLoading.vue";
import { ActionGetIPAddress } from "@/utils/helpers";

export default {
  components: {
    ProgressLoading,
  },
  name: "Landing",
  directives: { mask },
  mixins: [validationMixin],
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(4) },
    },
  },
  data: () => ({
    themeBackground: null,
    imageBackground: null,
    form: {
      accessdoc: null,
      accesscode: null,
      termsAcepted: false,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    accessname: "",
    loading: false,
    notExists: false,
    largura: null,
    ipUser: null,
  }),
  methods: {
    ...mapActions("auth", [
      "ActionGetMailingFirstName",
      "ActionMailingDoLogin",
    ]),
    async dologin() {
      this.promoCodeErrors.pop();
      this.loading = true;
      this.promoCodeErrors.pop();
      this.error.status = "ERROR";
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.loading = false;
        return;
      } else {
        this.loading = true;
        try {
          await this.ActionMailingDoLogin({
            DocNumber: this.form.accessdoc,
            AccessCode: this.form.accesscode,
            DeviceName: process.env.VUE_APP_API_DEVICE,
            IP: this.ipUser ? this.ipUser : "",
            OS:navigator.platform,
          });
          this.loading = false;
          location.href = "/";
        } catch (error) {
          this.promoCodeErrors.push(
            "CPF/CNPJ ou código de acesso incorretos"
          );
          this.error.status = "ERROR";
          this.loading = false;
        }
        this.loading = false;
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          break; // Saia do loop se o IP for obtido com sucesso
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarde 1 segundo antes de tentar novamente
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    await this.getIPAddressUser();
    this.loading = true;
    this.largura = window.screen.width;
    this.form.accesscode = this.$route.params.mailing;

    var result = await this.ActionGetMailingFirstName({
      AccessCode: this.form.accesscode,
      IP: this.ipUser ? this.ipUser : "",
      OS: navigator.platform,
    });
    if (result.data.code !== 200) {
      this.notExists = true;
      this.loading = false;
    } else {
      this.accessname = result.data.results.FirstName;
    }
    this.loading = false;
  },
  computed: {
    promoCodeErrors() {
      const errors = [];

      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.required && errors.push("Campo é obrigatório!");
      !this.$v.form.accessdoc.minLength &&
        errors.push("O CPF/CNPJ não está completo!");

      return errors;
    },
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
  },
};
</script>